const websiteConfigCollection = require('od-modules/collections/website.collection').getInstance();
const BasicAncillariesLoader = require('./loader/loader.basic');
const DebugAncillariesLoader = require('./loader/loader.debug');

const getLoaderClass = (data = {}) => websiteConfigCollection.isPbAncillariesMockEnabled()
    ? new DebugAncillariesLoader(data)
    : new BasicAncillariesLoader(data);

class AncillariesFetcher {
    constructor({service, action}) {
        this.service = service;
        this.action = action;
        this.subscribers = [];
    }

    subscribe({success = () => {}, failure = () => {}} = {}) {
        this.subscribers.push({success, failure});
    }

    getLoadData(resolve, reject) {
        return {
            service: this.service,
            action: this.action,
            subscribers: this.subscribers,
            resolve,
            reject,
        };
    }

    load(bookingInfo, options) {
        return new Promise((resolve, reject) => {
            websiteConfigCollection.getLoadedPromise()
                .then(() => getLoaderClass(this.getLoadData(resolve, reject)).load(bookingInfo, options));
        });
    }
}

module.exports = AncillariesFetcher;
